import { NgModule } from '@angular/core';
import { NavItemHelpComponent } from './components';

@NgModule({
    declarations: [],
    imports: [NavItemHelpComponent],
    exports: [NavItemHelpComponent],
})
export class NavItemHelpModule {}
